import ImageClass from "../../src/shell/Image";
import Question from "../../src/shell/Questions";
import { jump } from "../../src/shell/jump";
import { ann } from "../characters/Ann";
import { director } from "../characters/Director";
import { mc } from "../characters/MC";
import { images } from "./images";
import { V7AnnDirectorHotelAfter } from "./V7";

export const V7AnnDirectorHotel = async (): Promise<any> => {
    ImageClass.setImage(images.v7.AnnMCDirectorHotel_0, { transition: true, duration: 0.6 });
    director.talk(`Please, come inside, make yourself at home.`);
    mc.think(`It's not even his home... And yet, it looks like a pimp hotel.`);
    ImageClass.setImage(images.v7.AnnMCDirectorHotel_3);
    director.talk(`Sorry for not offering you a drink, this bottle is too expensive to waste.`);
    ImageClass.setImage(images.v7.AnnMCDirectorHotel_2);
    mc.talk(`What a douche.`, { method: "Whispering" });
    ImageClass.setImage(images.v7.AnnMCDirectorHotel_2.partials.AnnMCDirectorHotel_2_p);
    ann.talk(`Shhh!! He's gonna hear you.`);
    ImageClass.setImage(images.v7.AnnMCDirectorHotel_9);
    director.talk(`Like I said, you really impressed me.`);
    director.talk(`And I'm referring to the last part only.`);
    director.talk(`The rest sucked.`);
    director.talk(`No offense.`);
    ImageClass.setImage(images.v7.AnnMCDirectorHotel_9.partials.AnnMCDirectorHotel_9_p);
    ann.talk(`None taken.`);
    ImageClass.setImage(images.v7.AnnMCDirectorHotel_9);
    director.talk(`Tell me a bit about yourself.`);
    ImageClass.setImage(images.v7.AnnMCDirectorHotel_4);
    ann.talk(`Hmm... How can I start?`);
    ann.talk(`My name is Ann...`);
    ann.talk(`I'm nineteen years old...`);
    ann.talk(`I used to love reading but I don't do that anymore...`);
    ann.talk(`Lately I love experimenting with new stuff.`);
    ann.talk(`And that's it... I think.`);
    ann.talk(`Oh yeah, and I really wanna be an actress!`);
    ImageClass.setImage(images.v7.AnnMCDirectorHotel_9);
    director.talk(`Why did you chose to become an actress?`);
    ann.talk(`Mmm... It happened after I met ${mc.name}.`);
    ImageClass.setImage(images.v7.AnnMCDirectorHotel_9);
    director.talk(`Your agent I presume.`);
    mc.think(`I better play along so I won't ruin it for her.`);
    ImageClass.setImage(images.v7.AnnMCDirectorHotel_5);

    mc.talk(`Yes.`);
    ImageClass.setImage(images.v7.AnnMCDirectorHotel_9);
    director.talk(`Was he the one who convinced you to go this route?`);
    ImageClass.setImage(images.v7.AnnMCDirectorHotel_5);
    ann.talk(`You could say that, hehe.`);
    return jump(V7AnnDirectorHotel2, "V7AnnDirectorHotel2");
};

export const V7AnnDirectorHotel2 = async (): Promise<any> => {
    ImageClass.setImage(images.v7.AnnMCDirectorHotel_9);
    director.talk(`Let's talk business.`);
    director.talk(`I believe you know who I am, right?`);
    ImageClass.setImage(images.v7.AnnMCDirectorHotel_5);
    // ann.talk(`Yes of course.`);
    ann.talk(`You are Phil Malot, the greatest director in the industry!`);
    ImageClass.setImage(images.v7.AnnMCDirectorHotel_9);
    director.talk(`So you are aware of the connections I have.`);
    director.talk(`You've proven to me that you are willing to do whatever it takes to succeed.`);
    ImageClass.setImage(images.v7.AnnMCDirectorHotel_9.partials.AnnMCDirectorHotel_9_p);
    director.talk(`But don't get me wrong. I'm not going to hire you for a one hundred million dollar movie.`);
    director.talk(`You'll have to start small. Minor roles. At first you wouldn't even have a script, you will be an extra in the background.`);

    ImageClass.setImage(images.v7.AnnMCDirectorHotel_9);
    director.talk(`In time, you'll get bigger and bigger roles.`);
    mc.talk(`How's the pay?`);
    ImageClass.setImage({ ...images.v7.AnnMCDirectorHotel_6, partialsToDisplay: [images.v7.AnnMCDirectorHotel_9.partials.AnnMCDirectorHotel_9_p] });
    director.talk(`Don't worry, I won't take money from her, I'll get her these roles for free.`);
    mc.talk(`What? She needs to get paid!`);
    director.talk(`Not at first. That's my offer.`);
    ImageClass.setImage(images.v7.AnnMCDirectorHotel_6);
    ann.talk(`I'll do it!`);
    ImageClass.setImage(images.v7.AnnMCDirectorHotel_5);
    director.talk(`Wise choice.`);
    mc.think(`I hope she knows what she is doing.`);
    director.talk(`I already know the answer to my next question, but it's something I have to ask.`);
    director.talk(`How are you with nudity?`);
    ImageClass.setImage(images.v7.AnnMCDirectorHotel_9.partials.AnnMCDirectorHotel_9_p);
    ann.talk(`Nudity?`);

    return jump(V7AnnDirectorHotel2_Question, "V7AnnDirectorHotel2_Question");
};

export const V7AnnDirectorHotel2_Question = async (): Promise<any> => {
    await director.setQuestion(new Question({ text: `Yes, are you ok with appearing on the screen fully nude?`, options: { think: false }, key: `v7DirectorHotelAgreeToAnnForNudeMovies` })
        .option({ title: `Agree by staying silent`, key: true })
        .option({ title: `Intervene and say no`, key: false }));


    if (Question.globalAnswers.v7DirectorHotelAgreeToAnnForNudeMovies) {
        return jump(V7AnnDirectorHotel2_Question_Agree, "V7AnnDirectorHotel2_Question_Agree");

    } else {
        return jump(V7AnnDirectorHotel2_Question_Disagree, "V7AnnDirectorHotel2_Question_Disagree");

    }
};

export const V7AnnDirectorHotel2_Question_Agree = async (): Promise<any> => {
    await ann.set((properties) => {
        properties.v7ActressJob = true;
    });
    ann.talk(`Hmm...`);
    director.talk(`By the way you're dressed I expected a fast and direct answer.`);
    ImageClass.setImage(images.v7.AnnMCDirectorHotel_5);
    ann.talk(`Of course, I wouldn't mind appearing nude.`);
    director.talk(`Lift your shirt.`);
    ImageClass.setImage(images.v7.AnnMCDirectorHotel_9.partials.AnnMCDirectorHotel_9_p);
    ann.talk(`Ah...`);
    ann.talk(`Now?`);
    director.talk(`I need to see what I'm working with.`);
    ann.talk(`Why is that important?`);
    director.talk(`...`);
    ann.talk(`I mean, I will do what you want on set and all... But right now?`);
    director.talk(`......`);
    ann.talk(`Ok...`);
    ImageClass.setImage(images.v7.AnnMCDirectorHotel_10, { wait: true, duration: 1 });
    ImageClass.setImage(images.v7.AnnMCDirectorHotel_10.partials.AnnMCDirectorHotel_10_p, { duration: 1 });
    director.think(`*Sip*`);
    ImageClass.setImage(images.v7.AnnMCDirectorHotel_10, { duration: 1 });
    director.talk(`Excellent.`);
    director.talk(`You can lower it now.`);
    ImageClass.setImage(images.v7.AnnMCDirectorHotel_9);
    director.talk(`So this is what's going to happen.\nLeave your agent's number on your way out, and I'll give him a call whenever I have something for you.`);
    director.talk(`How's that sound?`);
    ImageClass.setImage(images.v7.AnnMCDirectorHotel_5);
    ann.talk(`Amazing!`);
    ImageClass.setImage(images.v7.AnnMCDirectorHotel_9);
    director.talk(`Great.\nThere's a bright future for you.`);
    director.talk(`AS LONG, as you'll do as I say.`);
    director.talk(`That will be all.`);
    return jump(V7AnnDirectorHotelEnd, "V7AnnDirectorHotelEnd");
};

export const V7AnnDirectorHotel2_Question_Disagree = async (): Promise<any> => {

    await ann.set((properties) => {
        properties.v7ActressJob = false;
    }); ImageClass.setImage(images.v7.AnnMCDirectorHotel_5);
    mc.talk(`Out of the question.`);
    ImageClass.setImage(images.v7.AnnMCDirectorHotel_6);
    ImageClass.setImage(images.v7.AnnMCDirectorHotel_9.partials.AnnMCDirectorHotel_9_p);
    director.talk(`Don't you want your client to succeed?`);
    mc.talk(`I do, but she can do it in an honest way.`);
    director.talk(`The most successful actresses have done it at one point.`);
    director.talk(`I can't believe I even have to say it.`);
    ImageClass.setImage(images.v7.AnnMCDirectorHotel_9.partials.AnnMCDirectorHotel_9_p);
    director.talk(`Consider finding a different agent.`);
    ann.talk(`Does that mean I won't get any part?`);
    ImageClass.setImage(images.v7.AnnMCDirectorHotel_9);
    director.talk(`I'll have to think about it, but as right now. The odds are slim.`);
    director.talk(`Leave your agent's number on your way out.`);

    return jump(V7AnnDirectorHotelEnd, "V7AnnDirectorHotelEnd");
};

export const V7AnnDirectorHotelEnd = async (): Promise<any> => {
    if (ann.properties.v7ActressJob) {
        // <action type="image" t="t" nb="false" wi="false">"Game/V7/V7AnnDirectorHotel/AnnMCDirectorHotel_11"</action>
        // <action type="image" animate="false" add="true" nb="false" wi="false">"Game/V7/V7AnnDirectorHotel/AnnMCDirectorHotel_11_p"</action>
        ImageClass.setImage({ ...images.v7.AnnMCDirectorHotel_11, partialsToDisplay: [images.v7.AnnMCDirectorHotel_11.partials.AnnMCDirectorHotel_11_p] }, { transition: true });
        ann.talk(`Oh my God! I can't believe it!`);
        ann.talk(`He liked me! And it's all thanks to you!`);
        mc.talk(`I'm excited for you, but don't get ahead of yourself.`);
        ann.talk(`I know, but it went better than I could have ever imagined.`);

    } else {
        ImageClass.setImage(images.v7.AnnMCDirectorHotel_11, { transition: true });
        ann.talk(`I can't believe it... I was so close.`);
        mc.talk(`Don't feel too bad about it, that guy is a jerk.`);
        ann.talk(`Maybe... But he is the one that could've open doors for me.`);
        mc.talk(`You'll make it on your own.`);
        ann.talk(`I'm not so sure...`);
        mc.talk(`Besides, he could still call.`);
        ann.talk(`I doubt it... But we'll see.`);
        ann.talk(`Anyway! Thanks for all the help.`);
        mc.talk(`Anytime.`);
    }


    ann.talk(`I need to go home, I'll talk to you later.`);
    mc.talk(`Cya Ann.`);

    return jump(V7AnnDirectorHotelAfter, "V7AnnDirectorHotelAfter");
};



